// removed by extract-text-webpack-plugin
module.exports = {"root":"_17ERXglcBIzcz9QnBztHls","inner":"_3J3PMadGIKlolI8KUu9RXt","header":"_2mjjG_x4mqofj-pN4wyhuO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/card.scss
// module id = 1182
// module chunks = 0